export default {
    confirm_user_username: 'Username',
    confirm_user_password: 'Password',
    confirm_user_confirm_password: 'Confirm Password',
    confirm_user_confirm_user: 'Confirm User',
    confirm_user_required_filed: 'Required field',
    confirm_user_forgot_password: 'Forgot Password?',
    confirm_user_change_password: 'Change Password',
    confirm_user_sign_in_with_google: 'Sign In With Google',
    confirm_user_confirm_new_password: 'Confirm New Password',
    page_not_found: 'Oops! We´ve hit a speed bump',
    page_not_found_message: 'The page you are looking for seems to be missing. If you need a ride someplace else, try one of the buttons on the left',
    confirm_user_email: 'Email',
    confirm_user_confirm_password_error: 'Passwords do not match',
    confirm_user_error: 'Error',
    confirm_user_confirm_password_sucess_message: 'Your password has been changed successfully. You can now log in with your new password.',
    confirm_user_confirm_password_sucess_verify_message: 'Your user has been verified successfully. You can now log in with your new password.',
    confirm_user_expired_code: 'This link has expired. Please contact your administrator to request a new one.',
    confirm_user_invalid_code: 'The code in invalid. Please contact your administrator to request a new one.',
};
